class Cache {
    constructor() {
        this.cache = null;
    }

    get() {
        return this.cache;
    }

    set(data) {
        this.cache = data;
    }

    clear() {
        this.cache = null;
    }
}

export default Cache;
